import {
  Row,
  CardHeader,
  Col,
  Card,
  CardBody,
  CardText,
  CardImg,
  Badge,
  Button,
} from 'reactstrap'

type Project = {
  title: string
  thumbnail: string
  tags: string[]
  link: string
}

const Projects = () => {
  const projects: Project[] = [
    {
      title: 'Dr Aline Proenca',
      thumbnail: 'images/aline.png',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://alineproenca.com.br/',
    },
    {
      title: 'Interage tv',
      thumbnail: 'images/interagetv.png',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://interage.tv/',
    },
    {
      title: 'Abrace Pipa',
      thumbnail: 'images/abrace.png',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://abracepipa.com.br/',
    },
    {
      title: 'Hotel Alimar',
      thumbnail: 'images/alimar.jpg',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://alimar.com.br/',
    },
    {
      title: 'Motiro',
      thumbnail: 'images/motiro.jpg',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'http://motiro.social/',
    },
    {
      title: 'RN Proteção',
      thumbnail: 'images/rn-protecao.jpg',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://rnprotecao.com.br/',
    },
    {
      title: 'Sanitize Ambiental',
      thumbnail: 'images/sanitize.jpg',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://sanitizeambiental.com.br/',
    },
    {
      title: 'Lopes Energia Solar',
      thumbnail: 'images/lopes-energia.jpg',
      tags: ['Figma', 'PHP', 'html5', 'Jquery', 'Scss', 'MySql'],
      link: 'https://lopesenergiasolar.com.br/',
    },
    {
      title: 'DNA Energia',
      thumbnail: 'images/dna-energia.jpg',
      tags: ['PHP', 'html5', 'Jquery', 'Scss', 'MySql'],
      link: 'http://dnasolarbrasil.com.br/',
    },
    {
      title: 'Pão Cadice',
      thumbnail: 'images/pao-cadice.jpg',
      tags: ['PHP', 'html5', 'Jquery', 'Scss', 'MySql'],
      link: 'https://paocadice.com.br/',
    },
    {
      title: 'RN Proteção',
      thumbnail: 'images/rnprotecao.png',
      tags: ['PHP', 'html5', 'JavaScript', 'Scss', 'MySql'],
      link: 'https://rnprotecao.com.br/',
    },
  ]

  return (
    <div>
      <small className="font-weight-bold d-block">Rescentes projetos</small>
      <Row>
        {projects.map((project, index) => (
          <Col md="6" className="my-3" key={index}>
            <Card>
              <CardHeader>{project.title}</CardHeader>

              <CardBody className="p-0" key={index}>
                <CardImg
                  src={project.thumbnail}
                  alt={project.title}
                  className="position-absolute w-100"
                />

                <div className="card-content">
                  <CardText>
                    <div>
                      {project.tags.map((tag, i) => (
                        <Badge
                          color="dark"
                          className="mx-1 my-2 shadow-none"
                          key={i}
                        >
                          {tag}
                        </Badge>
                      ))}
                    </div>
                    <Button
                      color="secondary"
                      target="_blank"
                      size="sm"
                      href={project.link}
                    >
                      ver ..
                    </Button>
                  </CardText>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default Projects
